/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 * EN:英文
 */
 export default {

   title: { SC:"Work-integrated Learning Digital Platform", TC: "Work-integrated Learning Digital Platform", EN: "Work-integrated Learning Digital Platform"}
   ,welcome: { SC:"欢迎登录", TC: "歡迎登錄", EN: "Welcome to Login"}
   ,userName: { SC:"用户编号", TC: "用戶編號", EN: "User ID"}
   ,password: { SC:"密码", TC: "密碼", EN: "Password"}
   ,login: { SC:"登录", TC: "登錄", EN: "Sign In"}

}